'use strict';

var DataInputView = require('components/devices/views/common/data_edit_dialog_view').Input;
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var ModbusModel = require('models/modbus').Modbus;
var SelectView = require('components/common/views/select_view');

var EditValueView = Marionette.LayoutView.extend({
    template: require('components/devices/templates/common/edit_value'),

    selectName: 'deviceValue',

    regions: {
        dataInputRegion: '#dataInput',
        valueSelection: '#value-selection',
    },

    ui: {
        save: '#js-save',
        message: '#js-error-message',
        errors: '#js-errors',
    },

    events: {
        'click @ui.save': 'validateForm',
        'changed.bs.select': 'selectValue',
    },

    templateHelpers: {
        error: i18n.TR('Für dieses Gerät sind keine Werte verfügbar.'),
    },

    initialize: function (options) {
        this.options = options;
        this.controller = options.controller;
        this.deviceID = options.deviceID;

        $.when
            .apply(
                $,
                this.controller.requestValuesForDevices(
                    {
                        readonly: false,
                        max: 1,
                    },
                    options.category + '/' + options.type,
                    [parseInt(this.options.deviceID)]
                )
            )
            .done($.proxy(this.setValues, this));
    },

    setValues: function (regs, coils) {
        if (regs.models === undefined && coils.models === undefined) {
            // no values available for this devices? -> show warning
            this.ui.message.removeClass('invisible');
            return;
        }

        var mapFunc = function (item) {
            return {
                name: i18n.DATAPOINT(item.attributes.group, item.attributes.name),
                id: item.attributes.value_ref,
            };
        };

        this.regs = _.sortBy(_.map(regs.models, mapFunc), function (i) {
            return i.name;
        });
        this.coils = _.sortBy(_.map(coils.models, mapFunc), function (i) {
            return i.name;
        });

        this.values = _.union(regs.models, coils.models);

        if (this.values.length == 0) {
            // no values available for this devices? -> show warning
            this.ui.message.removeClass('invisible');
            return;
        }

        this.showSelectView();
    },

    selectValue: function (event) {
        this.selectedValue = _.filter(this.values, function (value) {
            return value.attributes.value_ref == event.target.value;
        })[0];
        this.fetchValue();
    },

    fetchValue: function () {
        var self = this;
        Decorator.disableElement('.modal-dialog');

        var address = this.selectedValue.attributes.type + '_' + this.selectedValue.attributes.nr;

        var options = {};
        options[self.deviceID] = [address];
        this.controller.getRegisters(options, undefined, function (resp) {
            self.selectedValue.set('device', self.deviceID);
            self.selectedValue.set('id', parseInt(self.selectedValue.attributes.value_ref.substring(3)));
            self.selectedValue.set('enableRelativeMode', false);

            if (!resp || resp.unfetched) {
                self.ui.errors.show();
                return;
            }

            var values = resp.valuemap[self.deviceID];
            self.selectedValue.data = values;
            var value = values === undefined ? undefined : values[address];

            self.showDataInputView(self.selectedValue, value);
            Decorator.enableElement('.modal-dialog');
        });
    },

    validateForm: function (e) {
        e.preventDefault();

        var input = this.dataInputView;
        // no value selected? -> abort
        if (input === undefined) {
            return;
        }

        if (input.allFieldsValid()) {
            var form = Backbone.Syphon.serialize(input);
            Decorator.disableElement('.modal-dialog');
            var mbValue = new ModbusModel({
                id: input.model.get('nr'),
                device: input.model.get('device'),
                type: input.model.get('type'),
                value: parseInt(form.value || form.coil_select),
                value_ref: input.model.get('value_ref'),
                normalUser: true,
            });

            this.controller.saveValue(mbValue);
        }
    },

    showSelectView: function () {
        this.showChildView(
            'valueSelection',
            new SelectView({
                id: 'value',
                title: i18n.TR('Wert auswählen'),
                groups: [
                    {
                        groupName: i18n.TR('Register'),
                        items: this.regs,
                    },
                    {
                        groupName: i18n.TR('Coils'),
                        items: this.coils,
                    },
                ],
            })
        );
    },

    showDataInputView: function (value, init) {
        // allow only raw-value editing
        // -> "neutralize" format and unit information (for registers)
        if (value.get('type') == 'MBR') {
            value.attributes.format = '';
            value.attributes.is_unit_fixed = false;
            value.attributes.min = 0;
            value.attributes.max = 0;
            value.attributes.unit = '';
        }

        this.dataInputView = new DataInputView({
            model: value,
            controller: this.controller,
            initValue: init,
        });
        this.showChildView('dataInputRegion', this.dataInputView);
        this.ui.save.removeClass('disabled');
    },
});

module.exports = EditValueView;
